// extracted by mini-css-extract-plugin
export default {"wrapper":"PlantGroupList_wrapper__dRT8M","cardContent":"PlantGroupList_cardContent__9rnLD"};